import type { CanonicalFiles } from '../../../core/types.js';
import type { RulesOutput } from './types.js';

export function generatePermissions(_canonical: CanonicalFiles): RulesOutput[] {
  return [];
}
